<div *ngFor="let role of options$ | async; trackBy: trackByRole">
  <mat-checkbox
    [disabled]="disabled"
    [checked]="isSelected(role)"
    (change)="select(role, $event.checked)"
  >
    {{ role.name }}
  </mat-checkbox>
</div>
